import {
  publishClientSideMetrics,
  publishCustomMetrics,
} from "../../handler/ParentDataHandler";
import {
  filters,
  ONE_HOUR,
  INDUCT,
  INDUCT_ACTUALS,
  INDUCT_MHE_ACTUALS,
  AUTO_SCAN_INDUCT_LOADER,
} from "./PPAConstants";
import moment from "moment";
import { getTime } from "../../settings/SettingsUtil";
import { appendRegionSuffix, castToString, chainWalk } from "../../util/Util";
import { OPS_CLOCK_PROCESS, SHIFT_PLANNING } from "../../util/Constants";
import { getStationCode } from "../../network/NetworkUtil";
const momentTimezone = require("moment-timezone");

export function getPerformanceData(output) {
  const Fifteen = "15";
  const Thirty = "30";
  const Cumulative = "cumulative";
  const sixty = "60";
  const performanceOutput = {
    15: [],
    30: [],
    60: [],
    cumulative: [],
  };

  if (output.length === 0) {
    return performanceOutput;
  }

  const endDateTime = new Date(output[output.length - 1].time);
  fillWorkSlot(
    new Date(output[0].time),
    endDateTime,
    Fifteen,
    15,
    performanceOutput,
  );
  fillWorkSlot(
    new Date(output[0].time),
    endDateTime,
    Thirty,
    30,
    performanceOutput,
  );
  output.forEach((item) => {
    performanceOutput[Fifteen].forEach((data) => {
      if (data.time.toString() === new Date(item.time).toString()) {
        data.tph = item.tph;
        data.inductPPH = item.inductPPH;
        data.stowPPH = item.stowPPH;
        data.pickPPH = item.pickPPH;
        data.stagePPH = item.stagePPH;
      }
    });
    performanceOutput[Thirty].forEach((data) => {
      if (data.time.toString() === new Date(item.time).toString()) {
        data.tph = item.tph;
        data.inductPPH = item.inductPPH;
        data.stowPPH = item.stowPPH;
        data.pickPPH = item.pickPPH;
        data.stagePPH = item.stagePPH;
      }
    });
    performanceOutput[Cumulative].push({
      time: new Date(item.time),
      tph: item.tph,
      inductPPH: item.inductPPH,
      stowPPH: item.stowPPH,
      pickPPH: item.pickPPH,
      stagePPH: item.stagePPH,
    });
    performanceOutput[sixty].push({
      time: new Date(item.time),
      tph: item.tph,
      inductPPH: item.inductPPH,
      stowPPH: item.stowPPH,
      pickPPH: item.pickPPH,
      stagePPH: item.stagePPH,
    });
  });
  return performanceOutput;
}

function fillWorkSlot(
  startDateTime,
  endDateTime,
  granularity,
  min,
  performanceOutput,
) {
  while (startDateTime <= endDateTime) {
    performanceOutput[granularity].push({
      time: new Date(startDateTime),
      tph: -1,
      inductPPH: -1,
      stowPPH: -1,
    });
    startDateTime.setMinutes(startDateTime.getMinutes() + min);
  }
}

/**
 * This method return the refresh interval in milliseconds
 * @returns {number}
 */
export function getRefreshInterval() {
  return 60 * 1000;
}

export function getNewRefreshInterval() {
  return 15 * 60 * 1000;
}

export function logOperationalMetric(
  startTime,
  processName,
  metricName,
  isSuccess,
) {
  isSuccess
    ? publishToCSM({
        startTime: startTime,
        processName: processName,
        metricName: metricName,
      })
    : publishErrorToCSM({
        processName: processName,
        metricName: metricName,
      });
}

export function logCustomMetric(eventType, eventName) {
  let stationCode = getStationCode();
  publishCustomMetrics({
    eventType: eventType,
    eventName: eventName,
    stationCode: stationCode,
  });
}

function publishToCSM(args) {
  let metricValue = getTimeDiff(args.startTime);
  const countMetricReq = publishClientSideMetricsRequest(
    args.processName,
    args.metricName,
    1,
    metricTypeEnum.COUNT,
  );
  const timeMetricReq = publishClientSideMetricsRequest(
    args.processName,
    args.metricName,
    metricValue,
    metricTypeEnum.TIME,
  );
  publishClientSideMetrics(countMetricReq);
  publishClientSideMetrics(timeMetricReq);
}

export function publishErrorToCSM(args) {
  const countMetricReq = publishClientSideMetricsRequest(
    args.processName,
    args.metricName + "Error",
    1,
    metricTypeEnum.COUNT,
  );
  publishClientSideMetrics(countMetricReq);
}

export function publishCountToCSM(args) {
  const countMetricReq = publishClientSideMetricsRequest(
    args.processName,
    args.metricName,
    1,
    metricTypeEnum.COUNT,
  );
  publishClientSideMetrics(countMetricReq);
}

function getTimeDiff(time) {
  return Date.now() - time;
}

const metricTypeEnum = {
  COUNT: "count",
  TIME: "time",
};

function publishClientSideMetricsRequest(
  processName,
  metricName,
  metricValue,
  metricType,
) {
  return {
    processName: appendRegionSuffix(processName),
    metricName: metricName,
    metricValue: metricValue,
    metricType: metricType,
  };
}

export function getCumulativeSum(processData) {
  const dataPointList = processData.dataPointList.map((datapoint, index) => {
    if (datapoint.metricValue < 0) {
      return datapoint;
    }
    return processData.dataPointList.slice(0, index + 1).reduce((a, b) => ({
      ...datapoint,
      metricValue: getNonNegativeCumulativeSum(a.metricValue, b.metricValue),
    }));
  });
  return {
    ...processData,
    dataPointList: dataPointList,
  };
}

function getNonNegativeCumulativeSum(datapoint1, datapoint2) {
  return getNonNegativeValue(datapoint1) + getNonNegativeValue(datapoint2);
}

function getNonNegativeValue(datapoint) {
  return datapoint >= 0 ? datapoint : 0;
}

export function capDecimal(value) {
  if (value) {
    return Math.round((value + Number.EPSILON) * 10) / 10;
  } else {
    return 0;
  }
}

export function getFilteredPPAData(pvaData) {
  let filteredPPAData = {};
  if (
    pvaData &&
    Object.keys(pvaData.processPathAggregateData).length > 0 &&
    Object.keys(
      pvaData.overviewData.flowPVAData[pvaData.pvaTableData.granularity][0]
        .dataPointList,
    ).length > 0
  ) {
    filteredPPAData = pvaData.processPathAggregateData.filter((ppa) => {
      return pvaData.overviewData.flowPVAData[
        pvaData.pvaTableData.granularity
      ][0].dataPointList.some((pva) => {
        return ppa.time === pva.timeStampVal;
      });
    });
  } else {
    filteredPPAData =
      pvaData &&
      Object.keys(pvaData.processPathAggregateData).length > 0 &&
      Object.keys(
        pvaData.inbound.flowPVAData[pvaData.pvaTableData.granularity][0]
          .dataPointList,
      ).length > 0
        ? pvaData.processPathAggregateData.filter((ppa) => {
            return pvaData.inbound.flowPVAData[
              pvaData.pvaTableData.granularity
            ][0].dataPointList.some((pva) => {
              return ppa.time === pva.timeStampVal;
            });
          })
        : {};
  }

  if (Object.keys(filteredPPAData).length > 0) {
    filteredPPAData.forEach((timeFrame, index) => {
      let actualsHeadCount = 0;
      Object.keys(timeFrame["headCountDataMap"])
        .filter((f) => Object.keys(filters).includes(f))
        .forEach((key) => {
          let process = {};
          process = filteredPPAData[index]["headCountDataMap"][key];
          let headCounts = Object.keys(process).map(function (subProcess) {
            return filters[key].has(subProcess)
              ? capDecimal(process[subProcess][0].headCount)
              : 0;
          });
          let actuals = headCounts.reduce(function (acc, count) {
            return acc + count;
          }, 0);
          actualsHeadCount = actualsHeadCount + actuals;
          filteredPPAData[index]["headCountDataMap"][key]["Actuals"] =
            parseFloat(actuals).toFixed(1);
        });
      filteredPPAData[index]["headCountDataMap"]["Actual Hours"] =
        parseFloat(actualsHeadCount).toFixed(1);
    });
  }
  return filteredPPAData;
}

export function getPlannedHeadCountMap(pvaData) {
  const shiftPlans = pvaData.shiftPlans;
  const timedHeadCountMap = new Map();
  shiftPlans.forEach((plan) => {
    const timeStamp = plan.timeWindow.start;
    const processes = plan.requiredHeadcounts;
    for (const process in processes) {
      if (timedHeadCountMap.has(timeStamp)) {
        const headcountMap = timedHeadCountMap.get(timeStamp);
        const plannedValues = processes[process];
        if (headcountMap.has(process)) {
          headcountMap.set(
            process,
            headcountMap.get(process) + plannedValues.headcount,
          );
        } else {
          headcountMap.set(process, plannedValues.headcount);
        }
        timedHeadCountMap.set(timeStamp, headcountMap);
      } else {
        const headcountMap = new Map();
        headcountMap.set(process, processes[process].headcount);
        timedHeadCountMap.set(timeStamp, headcountMap);
      }
    }
  });
  aggregateHeadCounts(timedHeadCountMap);
  return timedHeadCountMap;
}

export function getProcessPathPlannedFPHMap(shiftPlans, processes) {
  let processPathPlannedFPHMap = new Map();
  for (let shiftPlan of Array.from(shiftPlans)) {
    const timeStamp = shiftPlan.timeWindow.start;
    const plannedFPHOfProcesses = new Map();
    for (let requiredProcess of Array.from(processes)) {
      for (let process of Object.keys(shiftPlan.requiredHeadcounts)) {
        if (process === requiredProcess) {
          plannedFPHOfProcesses.set(
            process,
            shiftPlan.requiredHeadcounts[process].plannedFph,
          );
          if (processPathPlannedFPHMap.get(timeStamp)) {
            if (requiredProcess in processPathPlannedFPHMap.get(timeStamp)) {
              processPathPlannedFPHMap
                .get(timeStamp)
                .set(
                  requiredProcess,
                  processPathPlannedFPHMap.get(timeStamp).get(requiredProcess) +
                    shiftPlan.requiredHeadcounts[process].plannedFph,
                );
            } else {
              processPathPlannedFPHMap
                .get(timeStamp)
                .set(
                  requiredProcess,
                  shiftPlan.requiredHeadcounts[process].plannedFph,
                );
            }
          } else {
            processPathPlannedFPHMap.set(timeStamp, plannedFPHOfProcesses);
          }
        }
      }
    }
  }
  return processPathPlannedFPHMap;
}

export function getPlannedFPHOfProcess(
  plannedProcessPathMap,
  updatedDateTime,
  process,
) {
  const plannedMap = plannedProcessPathMap.get(updatedDateTime);
  if (plannedMap) {
    return plannedMap.get(process) ? plannedMap.get(process) : 0;
  } else {
    let updatedplannedMap = getPlannedMap(
      plannedProcessPathMap,
      updatedDateTime,
    );
    if (updatedplannedMap) {
      return updatedplannedMap.get(process)
        ? updatedplannedMap.get(process)
        : 0;
    } else {
      return 0;
    }
  }
}

export function getPlannedMap(plannedDataMap, updatedDateTime) {
  let timeInString = updatedDateTime.split("T")[1];
  for (let [dateTime, map] of plannedDataMap) {
    let timeInTimestamp = dateTime.split("T")[1];
    if (
      timeInString === timeInTimestamp ||
      timeInString.split(":")[0] === timeInTimestamp.split(":")[0]
    ) {
      return map;
    }
  }
  return null;
}

export const isValidForPlannedFph = (hasPlan, granularity) => {
  return hasPlan && granularity === ONE_HOUR;
};

function aggregateHeadCounts(timedHeadCountMap) {
  timedHeadCountMap.forEach((value, key, map) => {
    const headCountMap = value;
    let totalHeadCount = 0;
    Object.keys(filters).forEach((key) => {
      const processSet = filters[key];
      let totalProcessHeadCount = 0;
      processSet.forEach((value) => {
        if (headCountMap.get(value)) {
          totalHeadCount += headCountMap.get(value);
          totalProcessHeadCount += headCountMap.get(value);
        }
      });
      headCountMap.set(key, totalProcessHeadCount);
    });
    headCountMap.set("Planned", totalHeadCount);
    map.set(key, headCountMap);
  });
}

export function getDataPointRange(index, dataPointList) {
  const dataPointStartDate = new Date(dataPointList[index].timeStampVal);
  const dataPointEndDate = new Date(dataPointList[index + 1].timeStampVal);
  return getTimeRange(dataPointStartDate, dataPointEndDate);
}

export function getLastDataPointRange(dataPoint, lastDatapoint15Mins) {
  const dataPointStartDate = new Date(dataPoint.timeStampVal);
  const dataPointEndDate = new Date(
    new Date(lastDatapoint15Mins.timeStampVal).getTime() + 15 * 60000,
  );
  return getTimeRange(dataPointStartDate, dataPointEndDate);
}

function getTimeRange(dataPointStartDate, dataPointEndDate) {
  return (
    dataPointStartDate.toTimeString().split(" ")[0].split(":")[0] +
    ":" +
    dataPointStartDate.toTimeString().split(" ")[0].split(":")[1] +
    "-" +
    dataPointEndDate.toTimeString().split(" ")[0].split(":")[0] +
    ":" +
    dataPointEndDate.toTimeString().split(" ")[0].split(":")[1]
  );
}

/**
 * Handles exception while reading from localStorage
 * @param key
 */
export function getFromLocalStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
}

/**
 * Handles exception while writing into localStorage
 * @param key
 * @param value
 */
export function saveIntoLocalStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {}
}
export const getPlanId = (data) => {
  const shiftPlans = data.shiftPlans;
  const approvedPlans = shiftPlans
    ? shiftPlans.filter((plan) => plan.status === "APPROVED")
    : null;
  const staticApprovedPlans = approvedPlans
    ? approvedPlans.filter(
        (approvedPlan) => approvedPlan.planVersion === "STATIC_V1",
      )
    : null;
  const approvedPlan = staticApprovedPlans
    ? staticApprovedPlans.sort(function (a, b) {
        return b.updatedAt - a.updatedAt;
      })[0]
    : null;
  return approvedPlan ? approvedPlan.planId : null;
};

export const getDynamicPlansForDiff = (data) => {
  const shiftPlans = data.shiftPlans;
  const sortedPlans = shiftPlans
    ? shiftPlans.sort((a, b) => b.updatedAt - a.updatedAt)
    : null;
  const validPlans = sortedPlans
    ? sortedPlans.filter((plan) => isValidDynamicPlan(plan))
    : [];
  const latestDynamicPlan = validPlans.length > 0 ? validPlans[0] : null;
  const previousDynamicPlan =
    validPlans.length > 1
      ? validPlans[1]
      : validPlans.length === 1
        ? validPlans[0]
        : null;
  return [latestDynamicPlan, previousDynamicPlan];
};

export const isPlanActedUpon = (plan) => {
  return (
    plan.status === SHIFT_PLANNING.PLAN_STATUS.APPROVED ||
    plan.status === SHIFT_PLANNING.PLAN_STATUS.REJECTED
  );
};

export const isValidDynamicPlan = (plan) => {
  return (
    plan.planVersion === SHIFT_PLANNING.PLAN_VERSIONS.DYNAMIC_V1 &&
    plan.status !== SHIFT_PLANNING.PLAN_STATUS.FAILED &&
    plan.status !== SHIFT_PLANNING.PLAN_STATUS.PENDING_CREATION
  );
};

export const isValidDynamicPlanV2 = (plan) => {
  return (
    (plan.planVersion === SHIFT_PLANNING.PLAN_VERSIONS.DYNAMIC_V1 ||
      plan.planVersion === SHIFT_PLANNING.PLAN_VERSIONS.DYNAMIC_V2) &&
    plan.status !== SHIFT_PLANNING.PLAN_STATUS.FAILED &&
    plan.status !== SHIFT_PLANNING.PLAN_STATUS.PENDING_CREATION &&
    plan.status !== SHIFT_PLANNING.PLAN_STATUS.CANCELLED
  );
};

export const getLatestDynamicPlanId = (data) => {
  const shiftPlans = data.shiftPlans;
  const sortedPlans = shiftPlans
    ? shiftPlans.sort((a, b) => b.createdAt - a.createdAt)
    : null;
  const validPlans = sortedPlans
    ? sortedPlans.filter((plan) => isValidDynamicPlanV2(plan))
    : [];
  return validPlans.length > 0 ? validPlans[0].planId : null;
};

export const arePlansSame = (plan1, plan2) => {
  if (!plan1 || !plan2) {
    return false;
  }
  return plan1.planId === plan2.planId && plan1.status === plan2.status;
};
/**
 * Is the given string a valid datetime string, i.e. ISO 8601 format 2022-06-11T08:00
 * @param dateTimeString
 * @returns {boolean}
 */
export function isValidDateTimeString(dateTimeString) {
  if (!dateTimeString) return false;
  return !isNaN(new Date(dateTimeString).getTime());
}

/**
 * Parse the dateTimeString into a Moment object in default (client browser) timezone
 * @param dateTimeString
 * @returns {moment.Moment|null}
 */
export function getMomentFromDateTimeString(dateTimeString) {
  if (!isValidDateTimeString(dateTimeString)) {
    return null;
  } else {
    return moment(dateTimeString);
  }
}

export function getBreaksFromSettingsInsights(
  settingsInsights,
  targetData,
  selectedCycle,
) {
  const { dayOfTheWeek = "", cycleId: targetCycle = "" } = targetData;
  const breaks = [];
  if (
    targetCycle &&
    selectedCycle &&
    castToString(targetCycle).toUpperCase() ===
      castToString(selectedCycle).toUpperCase() &&
    settingsInsights &&
    Array.isArray(settingsInsights[dayOfTheWeek])
  ) {
    const index = settingsInsights[dayOfTheWeek].findIndex((item) => {
      return (
        item["planDetails"] &&
        castToString(item["planDetails"]["cycleName"]).toUpperCase() ===
          selectedCycle.toUpperCase()
      );
    });
    if (index > -1) {
      const breakNameToSchedule = settingsInsights[dayOfTheWeek][index].breaks;
      if (breakNameToSchedule) {
        for (const [breakName, breakSchedule] of Object.entries(
          breakNameToSchedule,
        )) {
          breaks.push({
            ...breakSchedule,
            breakName,
          });
        }
      }
    }
  }
  return breaks;
}

export function roundMomentToNearest15Minutes(moment) {
  const remainder = moment.minutes() % 15;
  if (remainder <= 7) {
    moment.subtract("minutes", remainder);
  } else {
    moment.add("minutes", 15 - remainder);
  }
  return moment;
}

export function getBreaksFromOpsClockData(opsClockData, selectedCycle) {
  const breaks = [];
  const timezone = opsClockData.nodeTimeZone || momentTimezone.tz.guess();
  if (!opsClockData.opsClock) return breaks;

  let sortZeroClockEventIndex = -1;
  let inductClockEventIndex = -1;
  if (Array.isArray(opsClockData.opsClock.clockEvents)) {
    sortZeroClockEventIndex = opsClockData.opsClock.clockEvents.findIndex(
      (clockEvent) =>
        clockEvent.cycleName === selectedCycle &&
        clockEvent.process === OPS_CLOCK_PROCESS.TWILIGHT,
    );
    inductClockEventIndex = opsClockData.opsClock.clockEvents.findIndex(
      (clockEvent) =>
        clockEvent.cycleName === selectedCycle &&
        clockEvent.process === OPS_CLOCK_PROCESS.INDUCT,
    );
  }
  if (sortZeroClockEventIndex > -1 && inductClockEventIndex > -1) {
    const sortZeroClockEvent =
      opsClockData.opsClock.clockEvents[sortZeroClockEventIndex];
    const inductClockEvent =
      opsClockData.opsClock.clockEvents[inductClockEventIndex];
    if (
      sortZeroClockEvent.timeIntervals &&
      inductClockEvent.timeIntervals &&
      sortZeroClockEvent.timeIntervals[0] &&
      inductClockEvent.timeIntervals[0]
    ) {
      const sortZeroEndTime = sortZeroClockEvent.timeIntervals[0].endTime;
      const inductStartTime = inductClockEvent.timeIntervals[0].startTime;
      if (
        sortZeroEndTime &&
        inductStartTime &&
        sortZeroEndTime < inductStartTime
      ) {
        const sortZeroEndTimeMoment = momentTimezone
          .unix(sortZeroEndTime)
          .tz(timezone);
        const inductStartTimeMoment = momentTimezone
          .unix(inductStartTime)
          .tz(timezone);
        breaks.push({
          startTime: {
            formattedTime: roundMomentToNearest15Minutes(
              sortZeroEndTimeMoment,
            ).format("hh:mm A"),
          },
          endTime: {
            formattedTime: roundMomentToNearest15Minutes(
              inductStartTimeMoment,
            ).format("hh:mm A"),
          },
        });
      }
    }
  }

  if (!Array.isArray(opsClockData.opsClock.breaks)) return breaks;
  opsClockData.opsClock.breaks.forEach((item) => {
    if (!Array.isArray(item.timeIntervals)) return;
    item.timeIntervals.forEach((interval) => {
      const { startTime, endTime } = interval;
      if (!startTime || !endTime) return;
      breaks.push({
        startTime: {
          formattedTime: momentTimezone
            .unix(startTime)
            .tz(timezone)
            .format("hh:mm A"),
        },
        endTime: {
          formattedTime: momentTimezone
            .unix(endTime)
            .tz(timezone)
            .format("hh:mm A"),
        },
      });
    });
  });
  return breaks;
}

export function getStowWIPChartData(
  dataPointList,
  {
    isLMOCSEnabledForOpsClockData,
    settingsInsights,
    opsClockData,
    targetData,
    selectedCycle,
  },
  stowWIPUpperLimit = null,
) {
  if (!Array.isArray(dataPointList)) return [];
  let breaks = [];
  if (isLMOCSEnabledForOpsClockData) {
    breaks = getBreaksFromOpsClockData(opsClockData, selectedCycle);
  } else {
    breaks = getBreaksFromSettingsInsights(
      settingsInsights,
      targetData,
      selectedCycle,
    );
  }
  const newDataPointList = JSON.parse(JSON.stringify(dataPointList));
  return newDataPointList.map((dataPoint, index) => {
    if (index === 0) {
      dataPoint.metricValue = 0;
      dataPoint.isExcluded = true;
      return dataPoint;
    }
    dataPoint.isExcluded = false;
    if (stowWIPUpperLimit)
      dataPoint.metricValue = Math.min(
        stowWIPUpperLimit,
        dataPoint.metricValue,
      );
    const { timeStampVal } = dataPoint;
    if (isValidDateTimeString(timeStampVal)) {
      const currMoment = getMomentFromDateTimeString(timeStampVal);
      const index = breaks.findIndex((breakSchedule) => {
        const startMoment = getTime(breakSchedule.startTime.formattedTime);
        const endMoment = getTime(breakSchedule.endTime.formattedTime);
        return (
          startMoment &&
          endMoment &&
          isWithinTimeRange(
            currMoment.hours(),
            currMoment.minutes(),
            startMoment.hours(),
            startMoment.minutes(),
            endMoment.hours(),
            endMoment.minutes(),
          )
        );
      });
      if (index > -1) {
        dataPoint.metricValue = 0;
        dataPoint.isExcluded = true;
      }
    }
    return dataPoint;
  });
}

export function isWithinTimeRange(
  currHour,
  currMin,
  startHour,
  startMin,
  endHour,
  endMin,
) {
  //Edge case of which break timing span across two days
  if (startHour > endHour) {
    return (
      startHour * 60 + startMin < currHour * 60 + currMin ||
      currHour * 60 + currMin <= endHour * 60 + endMin
    );
  }
  return (
    startHour * 60 + startMin < currHour * 60 + currMin &&
    currHour * 60 + currMin <= endHour * 60 + endMin
  );
}

export function getDispatchDate(stationInsights) {
  if (
    stationInsights.shiftTimeRange &&
    stationInsights.shiftTimeRange.endTime
  ) {
    const {
      year,
      monthValue: month,
      dayOfMonth,
    } = stationInsights.shiftTimeRange.endTime;
    if (year && month && dayOfMonth) {
      return `${year}-${("0" + month).slice(-2)}-${("0" + dayOfMonth).slice(
        -2,
      )}`;
    }
  }
}

export function getTargetPphProcess(pphData, process) {
  if (pphData) {
    return pphData[process] ? capDecimal(pphData[process].targetPph) : 0;
  } else {
    return 0;
  }
}

export function getActualInductMHEDatapoints(flowPVAData) {
  if (flowPVAData[INDUCT_MHE_ACTUALS]) {
    return flowPVAData[INDUCT_MHE_ACTUALS].dataPointList.map(
      (dataPoint) => dataPoint.metricValue,
    );
  } else {
    return flowPVAData[INDUCT_ACTUALS].dataPointList.map((_) => "-");
  }
}

export function getActualInductManualDatapoints(flowPVAData) {
  return flowPVAData[INDUCT_ACTUALS].dataPointList.map((dataPoint, index) => {
    let totalInducted = dataPoint.metricValue;
    let mheInducted = chainWalk(
      () => flowPVAData[INDUCT_MHE_ACTUALS].dataPointList[index].metricValue,
      0,
    );
    let manualInducted = totalInducted - mheInducted;
    return manualInducted >= 0 ? manualInducted : "-";
  });
}

export function getPlannedInductMHEDatapoints(
  shiftPlans,
  plannedProcessPathMap,
  lengthOfDataPointList,
) {
  let plannedInductMHEDatapoints = getPlannedInductDatapoints(
    shiftPlans,
    plannedProcessPathMap,
    lengthOfDataPointList,
    AUTO_SCAN_INDUCT_LOADER,
  );
  return plannedInductMHEDatapoints.length > 0
    ? plannedInductMHEDatapoints
    : Array(lengthOfDataPointList).fill("-");
}

export function getPlannedInductManualDatapoints(
  shiftPlans,
  plannedProcessPathMap,
  lengthOfDataPointList,
) {
  let plannedInductManualDatapoints = getPlannedInductDatapoints(
    shiftPlans,
    plannedProcessPathMap,
    lengthOfDataPointList,
    INDUCT,
  );
  return plannedInductManualDatapoints.length > 0
    ? plannedInductManualDatapoints
    : Array(lengthOfDataPointList).fill("-");
}

export function getPlannedInductTotalDatapoints(
  shiftPlans,
  plannedProcessPathMap,
  lengthOfDataPointList,
) {
  let plannedManualDataPoints = getPlannedInductDatapoints(
    shiftPlans,
    plannedProcessPathMap,
    lengthOfDataPointList,
    INDUCT,
  );
  let plannedMHEDataPoints = getPlannedInductDatapoints(
    shiftPlans,
    plannedProcessPathMap,
    lengthOfDataPointList,
    AUTO_SCAN_INDUCT_LOADER,
  );
  let length = Math.max(
    plannedManualDataPoints.length,
    plannedMHEDataPoints.length,
  );
  let plannedTotalDataPoints = Array(length);

  for (let index = 0; index < length; index++) {
    let plannedManualDataPoint = chainWalk(
      () => plannedManualDataPoints[index],
      0,
    );
    let plannedMHEDataPoint = chainWalk(() => plannedMHEDataPoints[index], 0);
    plannedTotalDataPoints.push(plannedManualDataPoint + plannedMHEDataPoint);
  }

  return plannedTotalDataPoints.length > 0
    ? plannedTotalDataPoints
    : Array(lengthOfDataPointList).fill("-");
}

export function getPlannedInductDatapoints(
  shiftPlans,
  plannedProcessPathMap,
  lengthOfDataPointList,
  process,
) {
  return shiftPlans
    .filter((shiftPlan, index) => {
      return (
        shiftPlan.requiredHeadcounts[process] && index < lengthOfDataPointList
      );
    })
    .map((shiftPlan) =>
      getPlannedFPHOfProcess(
        plannedProcessPathMap,
        shiftPlan.timeWindow.start,
        process,
      ),
    );
}

export const isValid = (val) => {
  return !(val === null || val === undefined);
};

export const convertToFixedDP = (val, dp) => {
  return parseFloat(parseFloat(val).toFixed(isValid(dp) ? dp : 1));
};

export const isValidNewDynamicPlan = (currentPlanData, newPlanData) => {
  if (!newPlanData) {
    return false;
  }
  if (currentPlanData) {
    return currentPlanData.planId !== newPlanData.planId;
  }
  return true;
};

const getVolumeData = (inboundPackageProfileByInterval, interval, cycle) => {
  if (!inboundPackageProfileByInterval || !interval) {
    return null;
  }

  if (!inboundPackageProfileByInterval[interval]) {
    return null;
  }

  let volumeDataForCycle =
    inboundPackageProfileByInterval[interval].packageVolumeByProcessFlow;
  if (!volumeDataForCycle) {
    return null;
  }

  let key = cycle ? cycle.cycleId : Object.keys(volumeDataForCycle)[0];
  if (!key || !volumeDataForCycle[key]) {
    return null;
  }

  return volumeDataForCycle[key].packageVolumeBySize;
};

// Gets total inbound package volume counts from plan input by cycle.
export const getTotalInboundPackageVolumeByCycle = (input, cycles) => {
  let inboundPackageProfileByInterval = chainWalk(
    () => input.inboundPackageProfile.inboundPackageProfileByInterval,
    null,
  );
  if (inboundPackageProfileByInterval == null) {
    return null;
  }

  let volumeValues = {};
  for (let interval in inboundPackageProfileByInterval) {
    cycles.forEach((cycle) => {
      if (volumeValues[cycle.cycleId] == null) {
        volumeValues[cycle.cycleId] = 0;
      }
      let volumeSize = getVolumeData(
        inboundPackageProfileByInterval,
        interval,
        cycle,
      );
      if (volumeSize) {
        volumeValues[cycle.cycleId] += Object.values(volumeSize)[0];
      }
    });
  }
  return volumeValues;
};

// Gets the estimated time for completion for given process for given cycle.
export const getProcessETAForCycle = (input, processName, cycle) => {
  if (!input || !processName || !cycle) {
    return null;
  }

  const opsClockMap = chainWalk(() => input.opsclockInput.opsClockMap, null);

  if (!opsClockMap || !opsClockMap[cycle]) {
    return null;
  }

  const filteredListForProcess = opsClockMap[cycle].filter(
    (element) =>
      element &&
      element.process &&
      element.process.toUpperCase() === processName.toUpperCase(),
  );

  if (filteredListForProcess.length > 0 && filteredListForProcess[0].endTime) {
    return new Date(filteredListForProcess[0].endTime);
  }
  return null;
};

export const getETA = (pvaData, cycles, processName) => {
  if (!pvaData.dynamicShiftPlans.latest || !cycles || !cycles.selectedCycles) {
    return null;
  }
  return getProcessETAForCycle(
    pvaData.dynamicShiftPlans.latest.input,
    processName,
    cycles.selectedCycles[0],
  );
};
// Temporary comment to force git detection



// WEBPACK FOOTER //
// ./src/components/overview/utils/utils.js